import { InjectionToken } from '@angular/core';

/**
 * Führt eine seitenfüllende Browser-Navigation zur angegebenen URL durch.
 *
 * Hinter einem Injection-Token versteckt, damit OAuth-Weiterleitungen (die die
 * SPA vollständig verlassen) in Tests durch einen Spy ersetzt werden können.
 */
export type WindowNavigator = (url: string) => void;

export const WINDOW_NAVIGATOR = new InjectionToken<WindowNavigator>('WINDOW_NAVIGATOR', {
  providedIn: 'root',
  factory: () => (url: string) => {
    window.location.href = url;
  },
});
